export default "__VITE_ASSET__Dh_1L2qS__"